<template>
  <a class="aps-cpd-card"
    :class="{ 'aps-cpd-card--has-image': image_path, 'aps-cpd-card--has-more-events': events && events.length > 2 }"
    :href="href"
    :style="image_path ? `background-image: var(--gradient), url('${image_path}')` : undefined">
    <div class="aps-cpd-card__labels">
      <span v-if="is_aps_event" class="aps-cpd-card__label aps-cpd-card__label--aps-event">APS Event</span>
      <span v-for="(label,index) in labels" :key="index" :class="`aps-cpd-card__label aps-cpd-card__label--${label.type}`">
        {{ label.value }}
      </span>
    </div>
    <div class="aps-cpd-card__body">
      <div class="aps-cpd-card__general-infos">
        <span v-if="format" class="aps-cpd-card__format">{{ format }}</span>
        <span v-if="type" class="aps-cpd-card__type">{{ type }}</span>
      </div>
      <h4 class="aps-cpd-card__title">{{ title }}</h4>
      <p v-if="is_cpd_approved || cpd_hours" class="aps-cpd-card__cpd-details">
        <span v-if="is_cpd_approved" class="aps-cpd-card__cpd-approved">CPD Approved</span>
        <span v-if="cpd_hours" class="aps-cpd-card__cpd-hours">{{ cpd_hours }} CPD Hours</span>
      </p>
      <ul v-if="events && events.length"
        :class="`aps-cpd-card__events aps-cpd-card__events--${events.length}`">
        <li v-for="(event,index) in events" :key="index" class="aps-cpd-card__event">
          <span v-if="event.date" class="aps-cpd-card__date">{{ formatDate(event.date) }}</span>
          <span v-if="event.location.town" class="aps-cpd-card__location">{{ event.location.town }}</span>
        </li>
      </ul>
      <div v-if="events && events.length > 2" class="aps-cpd-card__events-counter">
        {{ events.length - 1 }} more</div>
    </div>
  </a>
</template>

<script>
  export default {
    name: 'aps-cpd-card',
    props: {
      is_aps_event: Boolean,
      is_cpd_approved: Boolean,
      cpd_hours: Number,
      format:  String,
      type: String,
      title: String,
      image_path: String,
      events: Array,
      labels: Array,
    },
    methods: {
      formatDate(str) {
          const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          const date = new Date(str)
          let month = months[date.getMonth()]
          month = month.substring(0, 3)
          return `${date.getDate()} ${month} ${date.getFullYear()}`
      },
    }
  } 
</script>